import React from 'react';
import { Input, Form } from 'antd';
import { FormInputProps } from '../types';

const FormInput: React.FC<FormInputProps> = ({
	label,
	value,
	onChange,
	type = 'text',
	required = false,
	placeholder = '',
	error = '',
	disabled = false,
	className = '',
}) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = type === 'number' ? parseFloat(e.target.value) || 0 : e.target.value;
		onChange(newValue);
	};

	return (
		<div className={className}>
			<Form.Item
				label={
					<span className="text-sm font-medium text-gray-700">
						{label} {required && <span className="text-red-500">*</span>}
					</span>
				}
				validateStatus={error ? 'error' : undefined}
				help={error}
				style={{ marginBottom: error ? 8 : 16 }}
			>
				<Input
					type={type}
					value={value}
					onChange={handleChange}
					placeholder={placeholder}
					disabled={disabled}
					className={`${error ? 'border-red-500' : ''} ${disabled ? 'bg-gray-100' : ''}`}
					style={{
						borderColor: error ? '#ef4444' : undefined,
						backgroundColor: disabled ? '#f3f4f6' : undefined,
					}}
				/>
			</Form.Item>
		</div>
	);
};

export default FormInput;
